export default __webpack_public_path__ + "static/daihocbinhduong-bc7d700ac028377099b407bd6b41501d.jpg";